import { Injectable } from '@angular/core';
import { api_routes, features } from '@app/consts';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { CustomReport, CustomReportVerbose, HardcodedReport, ReportSecurity, ServerReportElement } from "@app/modules/custom-reports/models/custom-report.model";
import { EnvironmentService } from "@app/core/services/environment.service";
import { PagedData } from "@app/modules/lookup/models/paged-data.model";

const headers = new HttpHeaders({
    'Content-Type': 'application/json',
});

@Injectable({
    providedIn: 'root'
})
export class CustomReportsService {

    constructor(
        private translate: TranslateService,
        private http: HttpClient,
        private envService: EnvironmentService
    ) {
    }


    postReport(reportData: any): Observable<any> {
        return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}`, reportData, {
            headers: headers,
            observe: 'response',
        })
            .pipe(
                catchError(err => throwError(err)),
                map(res => {
                    return res.body;
                })
            );
    }

    updateReport(reportId: string, reportData: any): Observable<CustomReportVerbose> {
        return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}`, reportData, {
            headers: headers,
            observe: 'response',
        })
            .pipe(
                catchError(err => throwError(err)),
                map(res => {
                    return res.body;
                })
            );
    }

    postReportElement(reportId, reportElement: ServerReportElement): Observable<any> {
        return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}/Elements`, reportElement, {
            headers: headers,
            observe: 'response',
        })
            .pipe(
                catchError(err => throwError(err)),
                map(res => {
                    return res.body;
                })
            );
    }

    putReportElement(reportId, reportElementId, reportElement: ServerReportElement): Observable<any> {
        return this.http.put<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}/Elements/${reportElementId}`, reportElement, {
            headers: headers,
            observe: 'response',
        })
            .pipe(
                catchError(err => throwError(err)),
                map(res => {
                    return res.body;
                })
            );
    }


    getReportById(reportId: string): Observable<CustomReportVerbose> {

        return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}`, {
            headers: headers,
            observe: 'response',
        })
            .pipe(
                catchError(err => throwError(err)),
                map(res => {
                    let report: CustomReportVerbose = res.body;
                    return report;
                })
            );
    }

    getReportElements(reportId: string): Observable<any> {
        return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}/Elements`, {
            headers: headers
        });
    }

    // getReportsByType(reportType: string, take?: string, skip?: string): Observable<CustomReport[]> {
    //     // console.log('getReportsByType', reportType);

    //     // TODO: comment out when API working
    //     return Observable.create(observer => {
    //         const obs: CustomReport[] = []
    //         let reportTypeId = '';

    //         if (reportType == 'Terminations') {
    //             reportTypeId = 'terminations_report';

    //         } else if (reportType == 'Employees') {
    //             reportTypeId = 'employees_report';
    //             obs.push(
    //                 {
    //                     type: "",
    //                     name: this.translate.instant('BasicHeadcountReport'),
    //                     id: "1",
    //                     createdBy: 'Lukasz M',
    //                     createdDate: '2022-01-01',
    //                     lastGenerated: '2022-07-22',
    //                     url: "/Reports/BasicHeadcountReport"
    //                 },
    //                 {
    //                     type: "",
    //                     name: this.translate.instant('BasicEmployeeReport'),
    //                     id: "2",
    //                     createdBy: 'Lukasz M',
    //                     createdDate: '2022-01-01',
    //                     lastGenerated: '2022-07-22',
    //                     url: "/Reports/BasicEmployeeReport"
    //                 },
    //                 {
    //                     type: "",
    //                     name: "Employee Bank Details",
    //                     id: "2",
    //                     createdBy: 'Lukasz M',
    //                     createdDate: '2022-01-01',
    //                     lastGenerated: '2022-07-22',
    //                     url: "/Reports/EmployeeBankDetailsReport"
    //                 },
    //             );
    //         } else if (reportType == 'TimeOff') {
    //             reportTypeId = 'timeoff_report';
    //         } else if (reportType == 'Configuration') {
    //             reportTypeId = 'configuration_report';
    //         } else if (reportType == 'Security') {
    //             reportTypeId = 'security_report';
    //         }

    //         let params = new HttpParams();
    //         params = params.append('Filter', `Type = "${reportTypeId}"`);
    //         skip ? params = params.append('skip', skip) : null;
    //         take ? params = params.append('take', take) : null;


    //         this.http.get<PagedData<CustomReport>>(`${this.envService.env.apiUrl}${api_routes.REPORTS}`, {
    //             headers: headers,
    //             params: params,
    //             observe: 'response',
    //         })
    //         .pipe(
    //             catchError(err => throwError(err)),
    //             map(res => {

    //                 return res.body;
    //             })
    //         )
    //         .subscribe(
    //             res => {
    //                 // console.log('getReportsByType', res.data);

    //                 res.data.forEach((report: CustomReport) => {
    //                     obs.push({
    //                         type: "",
    //                         name: report.name,
    //                         id: report.id,
    //                         createdBy: 'Lukasz M',
    //                         createdDate: '2022-01-01',
    //                         lastGenerated: '2022-07-22',
    //                         url: null
    //                     })
    //                 });
    //                 observer.next(obs);
    //                 observer.complete();
    //             }
    //         );
    //     });
    // }

    getHardcodedReports(reportType: string): Observable<HardcodedReport[]> {
        let reports = [
            {
                "id": "ReportEmployeeBankDetails",
                "name": "Employee Bank Details",
                "icon": "account_balance",
                "detail": "",
                "type": "Employees",
                "href": ["/Reports/Predefined/ReportEmployeeBankDetails"],
                "featureCode": features.ALLOW
            },
            {
                "id": "ReportBasicEmployeeReport",
                "name": this.translate.instant('BasicEmployeeReport'),
                "icon": "account_circle",
                "detail": "",
                "type": "Employees",
                "href": ["/Reports/Predefined/ReportBasicEmployeeReport"],
                "featureCode": features.ALLOW
            },
            {
                "id": "ReportHeadCountReport",
                "name": this.translate.instant('BasicHeadcountReport'),
                "icon": "people",
                "detail": "",
                "type": "Employees",
                "href": ["/Reports/Predefined/ReportHeadCountReport"],
                "featureCode": features.ALLOW
            },
            {
                "id": "ReportAbsenceReport",
                "name": this.translate.instant('AbsenceReport'),
                "icon": "people",
                "detail": "",
                "type": "TimeOff",
                "href": ["/Reports/Predefined/ReportAbsenceReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportAbsenceFinanceReport",
                "name": this.translate.instant('AbsenceFinanceReport'),
                "icon": "people",
                "detail": "",
                "type": "TimeOff",
                "href": ["/Reports/Predefined/ReportAbsenceFinanceReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportOutstandingAbsenceReport",
                "name": this.translate.instant('OutstandingAbsenceReport'),
                "icon": "people",
                "detail": "",
                "type": "TimeOff",
                "href": ["/Reports/Predefined/ReportOutstandingAbsenceReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportPendingTimeoffReport",
                "name": this.translate.instant('PendingTimeOffReport'),
                "icon": "people",
                "detail": "",
                "type": "TimeOff",
                "href": ["/Reports/Predefined/ReportPendingTimeoffReport"],
                "featureCode": "allow"
            },
            {
                'id': 'TimeoffCalculationEntriesReport',
                'name': this.translate.instant('TimeOffCalculationEntriesReport'),
                'icon': 'calculate',
                'detail': '',
                "type": "TimeOff",
                'href': ["/Reports/Predefined/TimeoffCalculationEntriesReport"],
                'featureCode': 'allow'
            },
            {
                'id': 'ReportTimeOffBuySellHoursReport',
                'name': this.translate.instant('TimeOffBuySellHoursReport'),
                'icon': 'shopping_cart_checkout',
                'detail': '',
                "type": "TimeOff",
                'href': ["/Reports/Predefined/ReportTimeOffBuySellHoursReport"],
                'featureCode': 'allow'
            },
            {
                'id': 'ReportTimeOffBuySellStatusReport',
                'name': this.translate.instant('TimeOffBuySellStatusReport'),
                'icon': 'shopping_cart_checkout',
                'detail': '',
                "type": "TimeOff",
                'href': ["/Reports/Predefined/ReportTimeOffBuySellStatusReport"],
                'featureCode': 'allow'
            },
            {
                "id": "ReportEmployeeLoginReport",
                "name": this.translate.instant('EmployeeLoginReport'),
                "icon": "login",
                "detail": "",
                "type": "Security",
                "href": ["/Reports/Predefined/ReportEmployeeLoginReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportGoalsReport",
                "name": this.translate.instant('GoalsReport'),
                "icon": "leaderboard",
                "detail": "",
                "type": "Performance",
                "href": ["/Reports/Predefined/ReportGoalsReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportToilBalanceReport",
                "name": this.translate.instant('ToilBalanceReport'),
                "icon": "people",
                "detail": "",
                "type": "Toil",
                "href": ["/Reports/Predefined/ReportToilBalanceReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportToilOccuranceReport",
                "name": this.translate.instant('ToilOccurrenceReport'),
                "icon": "people",
                "detail": "",
                "type": "Toil",
                "href": ["/Reports/Predefined/ReportToilOccuranceReport"],
                "featureCode": "allow"
            },
            {
                "id": "ReportReviewStatusReport",
                "name": this.translate.instant('ReviewStatusReport'),
                "icon": "people",
                "detail": "",
                "type": "Performance",
                "href": ["/Reports/Predefined/ReportReviewStatusReport"],
                "featureCode": "allow"
            },
        ]

        return of(reports.filter(report => report.type === reportType))
    }

    getNewReports(take?: number, skip?: number, filter?: string, sort?: string): Observable<PagedData<CustomReport>> {
        let params = new HttpParams();
        skip ? params = params.append('skip', skip) : null;
        take ? params = params.append('take', take) : null;
        filter ? params = params.append('filter', filter) : null;
        sort ? params = params.append('sort', sort) : null;

        return this.http.get<PagedData<CustomReport>>(`${this.envService.env.apiUrl}${api_routes.REPORTS}`, {
            headers: headers,
            params: params,
        })
    }


    public getCustomReports(): Observable<any> {
        return of([
            {
                "id": "p",
                "name": this.translate.instant('Employees'),
                "icon": "people",
                "detail": "",
                "href": ["/Reports/Custom/Type/Employees"],
                "featureCode": features.ALLOW
            },
            {
                "id": "p",
                "name": this.translate.instant('Terminations'),
                "icon": "people",
                "detail": "",
                "href": ["/Reports/Custom/Type/Terminations"],
                "featureCode": features.ALLOW
            },
            {
                "id": "p",
                "name": this.translate.instant('Time Off'),
                "icon": "alarm",
                "detail": "",
                "href": ["/Reports/Custom/Type/TimeOff"],
                "featureCode": features.ALLOW
            },
            {
                "id": "p",
                "name": this.translate.instant('Toil'),
                "icon": "alarm",
                "detail": "",
                "href": ["/Reports/Custom/Type/Toil"],
                "featureCode": features.ALLOW
            },
            {
                "id": "p",
                "name": this.translate.instant('Configuration'),
                "icon": "settings",
                "detail": "",
                "href": ["/Reports/Custom/Type/Configuration"],
                "featureCode": features.ALLOW
            },
            {
                "id": "p",
                "name": this.translate.instant('Security'),
                "icon": "security",
                "detail": "",
                "href": ["/Reports/Custom/Type/Security"],
                "featureCode": features.ALLOW
            },
        ]);
    }


    deleteReport(reportId: string): Observable<any> {
        return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}`, {
            headers: headers
        });
    }


    deleteReportElement(reportId: string, elementId: string) {
        return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${reportId}/Elements/${elementId}`, {
            headers: headers
        });
    }

    getReportsSecurity(take?: number, skip?: number, sort?: string, filter?: string, asOf?: string): Observable<PagedData<ReportSecurity>> {
        let params = new HttpParams();
        skip ? params = params.append('skip', skip) : null;
        take ? params = params.append('take', take) : null;
        filter ? params = params.append('filter', filter) : null;
        sort ? params = params.append('sort', sort) : null;
        asOf ? params = params.append('asOf', asOf) : null;

        return this.http.get<PagedData<ReportSecurity>>(`${this.envService.env.apiUrl}${api_routes.SECURITY}/${api_routes.REPORTS}`, {
            headers: headers,
            params: params,
        });
    }

    addReportSecurity(reportId: string, roleId: string): Observable<any> {
        return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.SECURITY}/${api_routes.REPORTS}/${api_routes.ROLE}/${roleId}/${api_routes.REPORT}/${reportId}`, null, {
            headers: headers
        });
    }

    removeReportSecurity(reportId: string, roleId: string): Observable<any> {
        return this.http.delete<any>(`${this.envService.env.apiUrl}${api_routes.SECURITY}/${api_routes.REPORTS}/${api_routes.ROLE}/${roleId}/${api_routes.REPORT}/${reportId}`, {
            headers: headers
        });
    }
}
